import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import scheduleMarkup from '../markup2/schedule.js';
import scheduleMarkupWithIcons from '../markup2/scheduleWithIcons.js';
import programDeskMarkup from '../markup2/programDesk.js';
import programDeskMarkupList from '../markup2/programDeskList.js';
import eventsDeskMarkup from '../markup2/eventDesk.js';
import scheduleMarkupTimeLine from '../markup2/scheduleTimeLine.js';
import toolsMarkup from '../markup/tools.js';

import eventJs from './events.js';
import programJs from './programms.js';
import filmApplicationsForConsiderJS from './filmApplicationsForConsider.js';


// import modalInfo from '../lk-catalogs/modal_one_txt_only.js';

import cropWrap from '../tools/cropWrapper.js';

import tools from '../tools/tools.js';

const scheduleCard = document.querySelector('#FestScheduleCard');
const cropWrapNode = scheduleCard.querySelector('#scheduleCardImage');

const loaderSpinnerId = 'loader-enterprises';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);

const mainTabPane = document.querySelector('#FestSchedule');
const mainTabPaneBTAdd = mainTabPane.querySelector('button[name=add]');
const mainTabPaneBTReload = mainTabPane.querySelector('button[name=refresh]');
const mainTabPaneBody = mainTabPane.querySelector('div[name=body]');
const mainTabPaneCalendarButtons = mainTabPane.querySelector('div[name=calendarDays]');


const selectTimeZone = mainTabPane.querySelector('select[name=listTimeZone]');
const selectTimeToDisplay= mainTabPane.querySelector('select[name=typeDateToDisplay]');


const newScheduleCellCardPicker = document.querySelector('#newScheduleCellPicker');
const newScheduleCellCardEditor = document.querySelector('#newScheduleCellSCard');

const programDesk = document.querySelector('#newScheduleCellSCardPickerProgram');
const programDeskSearch = programDesk.querySelector('input[name=search]');

const mainTabPaneBTDataDisplay =  programDesk.querySelector('button[name=typeDataDisplay]');
const mainTabPaneBTDataSort =  programDesk.querySelector('button[name=typeDataSort]');
const cardProgrammOpenDesk = newScheduleCellCardEditor.querySelector('button[name=programDesk]');

const eventDesk = document.querySelector('#newScheduleCellSCardPickerEvent');
const eventDeskSearch = eventDesk.querySelector('input[name=search]');
const eventDeskCreate = eventDesk.querySelector('button[name=add]');



// const newScheduleCellCardSimple = document.querySelector('#newScheduleCell_simpleRow');
const timeStartHourSelector = newScheduleCellCardEditor.querySelector('select[name=time_start_hour]');
const timeEndHourSelector = newScheduleCellCardEditor.querySelector('select[name=time_end_hour]');

const newScheduleCellCardEditorTitle = newScheduleCellCardEditor.querySelector('h5[name=modal-title]');

const programSelector = newScheduleCellCardEditor.querySelector('select[name=program]');
const programFilms = newScheduleCellCardEditor.querySelector('i[name=bodyProgrammFilms]');
const programInfoDiv = newScheduleCellCardEditor.querySelector('div[name=programInfo]');
const programInfo = newScheduleCellCardEditor.querySelector('i[name=bodyProgrammInfo]');



const cardMainActiveBlock = newScheduleCellSCard.querySelector('div[name=mainActiveBlock]');
const cardProgramBlock = newScheduleCellSCard.querySelector('div[name=programBlock]');



const cardEventBlock = newScheduleCellSCard.querySelector('div[name=eventBlock]');
const cardEventBlockImg = cardEventBlock.querySelector('img[name=imgEvent]');
const cardEventBlockTitle = cardEventBlock.querySelector('b[name=title]');
const cardEventBlockDescription = cardEventBlock.querySelector('small[name=descriptionTXT]');

const locationSelector = newScheduleCellCardEditor.querySelector('select[name=location]');
const hallsSelector = newScheduleCellCardEditor.querySelector('select[name=halls]');
const streamsSelector = newScheduleCellCardEditor.querySelector('select[name=streams]');
const streamsSelectorOn = newScheduleCellCardEditor.querySelector('select[name=streamON]');



const timeStartDaySelector = newScheduleCellCardEditor.querySelector('select[name=time_start_day_month]');
const timeEndDaySelector = newScheduleCellCardEditor.querySelector('select[name=time_end_day_month]');

const timeStartMinSelector = newScheduleCellCardEditor.querySelector('select[name=time_start_min]');
const timeEndMinSelector = newScheduleCellCardEditor.querySelector('select[name=time_end_min]');


const cellAreaTitle = newScheduleCellCardEditor.querySelector('textarea[name=title]');
const cellEditorSubmit = newScheduleCellCardEditor.querySelector('button[name=submit]');
const cellEditorRemove = newScheduleCellCardEditor.querySelector('button[name=remove]');


let scheduleImageToUpload = null;
let scheduleImageToDelete = false;
let currentscheduleDayIndex = 0;
let currentscheduleDayNumber = 6;
let dataToProgramDesk = false;

let arrLocations = false;
let arrPrograms = false;
let arrFilms = false;
let arrEvents = false;
// let fest

let startDay = null;
let endDay = null;
let dayDataFromServer = null;
let currentScheduleID = false;
let continueCreateEventBool = false;
let continueCreateEventId = 0;

let availableStreams = false;

cropWrap.init(cropWrapNode, false, {
  dataName: 'none',
  // aspectRatio: 1,
  onSave: (blob) => {
    scheduleImageToUpload = blob;
  },
  onDelete: () => {
    scheduleImageToDelete = true;
  }
});

const menuBt = document.querySelector('#MenuSchedule');

function initFirstSetup(argument) {

  if (mainTabPaneCalendarButtons.innerHTML.length < 10) {

  tools.removeOptions(selectTimeZone);
  for (let i = -11; i < 12; i++) {
    let opt = document.createElement('option');
    opt.value = i;
    
    if(i > 0)
      opt.innerHTML = '+'+i;
    else
      opt.innerHTML = i;
    
    if(i == 3)
      opt.innerHTML += ' (MOSCOW)';

    selectTimeZone.appendChild(opt);
  }
  if(!arrLocations)

    xhr.request = {
      metod: 'GET',
      url: 'places',
      data: '',
      callbackSuccess: onSuccessPointsLoad
    };
  

  if(!arrPrograms)
    reloadPrograms();

  if(!arrFilms)
    xhr.request = {
      metod: 'GET',
      // url: `festival/${auth.currentFestival}/fimlsInFestival`,
      url: `filmsInFestival/${auth.currentFestival}`,
      data: '',
      callbackSuccess: onSuccessLoadFilms
    };


   xhr.request = {
      metod: 'GET',
      url: `festival/${auth.currentFestival}/scheduleInfo`,
      data: '',
      callbackSuccess: onSuccessFestInfo
    };
  } else 
    loadOneDay();   
  

};

function  reloadPrograms() {
    arrPrograms = [];

    xhr.request = {
      metod: 'GET',
      url: 'filmPrograms/orderby/abs',
      data: '',
      callbackSuccess: onSuccessLoadAllProgramms
    };
  // body...
}


const onSuccessLoadFilms = (servarAnswer) => {
  arrFilms = [];  
  if (servarAnswer.status === 200)
    if(servarAnswer.data.films)
      arrFilms = servarAnswer.data.films;
    // console.log(arrFilms);


  if(arrPrograms&& arrFilms)
    runProgramDeskMarkup(arrPrograms, arrPrograms, arrFilms);
};



mainTabPaneBTDataDisplay.addEventListener('click', function () {
  // 0 - список
  // 1 - только номера заявок
  // 2 - иконки
  // alert();
  let typeDataDisplay = mainTabPaneBTDataDisplay.value;
  mainTabPaneBTDataDisplay.classList.remove(`iconDataDisplay${typeDataDisplay}`);

  ++typeDataDisplay;
  if (typeDataDisplay === 2)
    typeDataDisplay = 0;

  mainTabPaneBTDataDisplay.value = typeDataDisplay;
  mainTabPaneBTDataDisplay.classList.add(`iconDataDisplay${typeDataDisplay}`);
  
  searchInProgramDeskSearch();
});




mainTabPaneBTDataSort.addEventListener('click', function () {
  // 0 - список
  // 1 - только номера заявок
  // 2 - иконки
  // alert();
  let typeDataSort = mainTabPaneBTDataSort.value;
  mainTabPaneBTDataSort.classList.remove(`iconDataSort${typeDataSort}`);

  ++typeDataSort;
  if (typeDataSort === 1)
    typeDataSort = -1;

  mainTabPaneBTDataSort.value = typeDataSort;
  mainTabPaneBTDataSort.classList.add(`iconDataSort${typeDataSort}`);
  
  searchInProgramDeskSearch();
});






cardProgrammOpenDesk.addEventListener('click', function () {

  if (!programSelector.disabled) {
    $(newScheduleCellCardEditor).modal('hide');
    programDeskSearch.value = '';
    searchInProgramDeskSearch();
    setTimeout(function() { 
      $(programDesk).modal('show');
    },500);
  }
});
    
programFilms.addEventListener('click', function () {

  $(newScheduleCellCardEditor).modal('hide');
  programJs.publicoOenCardProgram(programFilms.getAttribute('programID'));
});



programSelector.addEventListener('change', () => {
  programSelect(programSelector.options[programSelector.selectedIndex].innerHTML);
});

 function  programSelect(pName) {
    if(cellAreaTitle.classList.contains('notEdited')){
      cellAreaTitle.value = pName;
      cellAreaTitleVallidate();
    }
    displayFilmsInProgramms();
    if(programSelector.value === 0)
      cardMainActiveBlock.classList.add('divDisabled');
    else
      cardMainActiveBlock.classList.remove('divDisabled');
      // cardMainActiveBlock.disabled = false;
     // body...
 }
function displayFilmsInProgramms (){
  programFilms.innerHTML = '';
    programInfo.innerHTML = '';
  let totalSec = 0;
  if(arrPrograms && arrFilms){
    arrPrograms.forEach((pElem) => {
      if(tools.checkEqualTwoInt(pElem.id, programSelector.value)){


        programInfo.innerHTML = tools.getNameTypePrograms(pElem.type);
        programInfo.innerHTML += '<br>';

        let canVoteStatus = 'Голосование запрещено';
        if(pElem.canVote)
          if(parseInt(pElem.canVote, 10) === 1)
            canVoteStatus = 'Голосование разрешено';


        programInfo.innerHTML += canVoteStatus;
        programInfo.innerHTML += '<br>';
        programFilms.setAttribute('programID',programSelector.value);

        if(pElem.films){
          pElem.films.forEach((pfElem) => {
            arrFilms.forEach((fElem) => {
              if(tools.checkEqualTwoInt(pfElem.filmIDfk, fElem.id)){
                programFilms.innerHTML += `${fElem.name}<br>`;
                totalSec += parseInt(fElem.long, 10);
              }
            })
          });
        }

        let value = totalSec;
        // let lhours = parseInt(value/(60*60), 10);
        // let lmins = parseInt(value/(60), 10);
        let lsec = value%(60);
        value -= lsec;
        value = value/60;
        let lmins = value%(60);;
        value -= lmins;
        value = value/60;
        let lhours =value;

        if(lmins < 10)
          lmins = `0${lmins}`;

        if(lsec < 10)
          lsec = `0${lsec}`;

        value = `${lhours}:${lmins}:${lsec}`;
        
        programInfo.innerHTML += value;

      }
    });

  }
}
const onSuccessLoadAllProgramms = (servarAnswer) => {
  
  arrPrograms = [];
  if (servarAnswer.status === 200)
    if(servarAnswer.data.programs);
    arrPrograms = servarAnswer.data.programs;

  tools.removeOptions(programSelector);
  let opt = document.createElement('option');
    opt.value = 0;
    opt.innerHTML = 'Выберите программу';
    opt.disabled = true;
    opt.selected = true;
    programSelector.appendChild(opt);


  arrPrograms.forEach((pElem) => {
    // console.log(pElem);
    let opt = document.createElement('option');
    opt.value = pElem.id;
    opt.innerHTML = pElem.name;
    programSelector.appendChild(opt);
  });

  if(arrPrograms&& arrFilms)
    runProgramDeskMarkup(arrPrograms, arrPrograms, arrFilms);


};

const onSuccessPointsLoad = (servarAnswer) => {
  if (servarAnswer.status === 200) {
    arrLocations = servarAnswer.data;

    tools.removeOptions(locationSelector);
    // let firstHall
    arrLocations.forEach((elem) => {
      let opt = document.createElement('option');
      opt.value = elem.id;
      opt.innerHTML = elem.name;
      if(elem.main)
        opt.selected = true;

      locationSelector.appendChild(opt);
    });

    let opt = document.createElement('option');
    opt.value = 0;
    opt.innerHTML = '--------------';
    opt.disabled = true;
    locationSelector.appendChild(opt);

    opt = document.createElement('option');
    opt.value = 0;
    opt.innerHTML = 'Без локации';
    opt.disabled = false;
    locationSelector.appendChild(opt);

    displayHalls();
  }
};

locationSelector.addEventListener('change', () => displayHalls());

function displayHalls() {

  tools.removeOptions(hallsSelector);
  if(arrLocations)
    arrLocations.forEach((elem) => {
      if(tools.checkEqualTwoInt(elem.id, locationSelector.value)) {
        if(elem.halls){
          hallsSelector.disabled = false;
          let fHall = true;
          elem.halls.forEach((hElem) => {
              let opt = document.createElement('option');
              opt.value = hElem.id;
              if(hElem.name)
                opt.innerHTML = hElem.name;
              else
                opt.innerHTML = 'Основной зал';

              if(fHall){
                fHall = false;
                opt.selected = true;
              }
              hallsSelector.appendChild(opt);
          });
        } else
          hallsSelector.disabled = true;

      }
    });
}

const onSuccessFestInfo = (servarAnswer) => {
  mainTabPaneCalendarButtons.innerHTML = '';
  // document.querySelector(`#${loaderSpinnerId}`).remove();
  if (servarAnswer.status === 200) {

    let i = 0;
    startDay = strToDate(servarAnswer.data.tsStart);
    endDay = strToDate(servarAnswer.data.tsEnd);
    selectTimeZone.value = servarAnswer.data.tTimeZone;
  
    displayCalendarDays();
    loadOneDay();   
  }

};

selectTimeZone.addEventListener('change', () => displayDataOfOneDay());
selectTimeToDisplay.addEventListener('change', () => displayCalendarDays());
mainTabPaneBTReload.addEventListener('click', () => {
  loadOneDay();
  reloadPrograms();
  // alert('reloadPrograms();');
});

function displayCalendarDays () {
    let firstDay = new Date(startDay.getTime()); 
    let HTMLStackBt = '';
    let i = 0;
    const months = ["Января", "Февраля", "Марта", "Апреля", "мая", "Июня", "Июля", "Августа", "Сентября", "Октября", "Ноября", "Декабря"];
    const dayOfWeek = [ "вс", "пн", "вт", "ср", "чт", "пт", "сб"];
    
    tools.removeOptions(timeStartDaySelector);
    tools.removeOptions(timeEndDaySelector);


    do {

      let choosedBT = '';
      if (parseInt(currentscheduleDayIndex, 10) == i) {
        currentscheduleDayNumber = firstDay.getDate();
        choosedBT = ' choosed ';
      }

      let strTimeToDisplay = '';
      if (selectTimeToDisplay.value == 1) 
        strTimeToDisplay = `${firstDay.getDate()}.${firstDay.getMonth() +1 }`;
      else if (selectTimeToDisplay.value == 2)
        strTimeToDisplay = `${firstDay.getDate()}.${firstDay.getMonth() + 1 } (${dayOfWeek[firstDay.getDay()]})`;
      else if (selectTimeToDisplay.value == 3)
        strTimeToDisplay = `${firstDay.getDate()} ${months[firstDay.getMonth()]}`;
      else if (selectTimeToDisplay.value == 4)
        strTimeToDisplay = `${firstDay.getDate()} ${months[firstDay.getMonth()]} (${dayOfWeek[firstDay.getDay()]})`;
      
      // if(i%2 ==0)
      HTMLStackBt += `<div id="FestSchedule-${firstDay.getDate()}" 
                              name="schedule_stack_buttons" 
                              schedulebuttonindex ="${i}"  
                              dayNumber = "${firstDay.getDate()}"  
                              class="btn-schedule ${choosedBT}" 
                              >${strTimeToDisplay} </div>`;

      let opt = document.createElement('option');
      let opt2 = document.createElement('option');
      opt.value = firstDay.getDate();
      opt2.value = firstDay.getDate();

      opt.setAttribute('month',firstDay.getMonth());
      opt2.setAttribute('month',firstDay.getMonth());
      opt.setAttribute('year',firstDay.getFullYear());
      opt2.setAttribute('year',firstDay.getFullYear());

      opt.innerHTML = strTimeToDisplay;
      opt2.innerHTML = strTimeToDisplay;

      timeStartDaySelector.appendChild(opt);
      timeEndDaySelector.appendChild(opt2);

      ++i;
      firstDay.setDate(firstDay.getDate() + 1);

      if(firstDay.getDate() == endDay.getDate() && firstDay.getMonth() ==  endDay.getMonth() && firstDay.getFullYear() == endDay.getFullYear())
        i = 29;

    } while(i < 30 );
    
    mainTabPaneCalendarButtons.innerHTML = HTMLStackBt;// let HTMLlistA = '';
}
mainTabPaneCalendarButtons.addEventListener('click', function (evt) {
  evt.preventDefault();
  
  if (evt.target.attributes.schedulebuttonindex) {
     let allBtDays = mainTabPaneCalendarButtons.querySelectorAll('div');
     mainTabPaneCalendarButtons.querySelectorAll('div').forEach((element) => {
      element.classList.remove('choosed');
    });
    
    evt.target.classList.add('choosed');
    currentscheduleDayIndex = evt.target.attributes.schedulebuttonindex.nodeValue;
    currentscheduleDayNumber =  evt.target.attributes.dayNumber.nodeValue;
    timeStartDaySelector.value = currentscheduleDayNumber;
    timeEndDaySelector.value = currentscheduleDayNumber;

    loadOneDay();
    // if(evt.target.class)
  };

});

function strToDate(dtStr) {
  // console.log(dtStr);
  let dateParts = dtStr.split("-");
  let timeParts = dateParts[2].split(" ")[1].split(":");
  dateParts[2] = dateParts[2].split(" ")[0];
  // console.log(dateParts);
  // console.log(timeParts);
  // month is 0-based, that's why we need dataParts[1] - 1
  return  new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2], timeParts[0], timeParts[1], timeParts[2]);
};
function loadOneDay(){

  scheduleMarkup.drawMarkupInContainer(loaderSpinnerMarkup);
  // console.log(selectTimeZone.value);
  xhr.request = {
      metod: 'GET',
      url: `schedule/${currentscheduleDayNumber}/timeZone/${selectTimeZone.value}`,
      data: '',
      callbackSuccess: (servarAnswer) => {
        document.querySelector(`#${loaderSpinnerId}`).remove();
        if (servarAnswer.status === 200) {
          dayDataFromServer = servarAnswer.data.day;
          availableStreams = servarAnswer.data.availableStreams;

          displayDataOfOneDay();
          displaySelectWithAvailStreams();
        }

      }
    };
    // console.log('Загрузка день: ' + currentscheduleDayNumber);
}
// работа с селектором
function displaySelectWithAvailStreams () {
  

  tools.removeOptions(streamsSelector);

  let opt = document.createElement('option');
  opt.value = false;
  opt.innerHTML = 'Трансляция отсутствует';
  streamsSelector.appendChild(opt);


  opt = document.createElement('option');
  // opt.value = elem.id;
  opt.innerHTML = '-----------------------';
  opt.disabled = true;
  streamsSelector.appendChild(opt);

  if(availableStreams)
    availableStreams.forEach((elem) => {

      let opt = document.createElement('option');
      opt.value = elem.id;
      opt.innerHTML = elem.name;
      streamsSelector.appendChild(opt);
      
    });
  streamsSelector.value = false;
  streamsSelectorOn.classList.add('divDisabled');
}


streamsSelector.addEventListener('change', () => {

    if (streamsSelector.value)
      streamsSelectorOn.classList.remove('divDisabled');
    else
    streamsSelectorOn.classList.add('divDisabled');
});



function displayDataOfOneDay () {
  if(mainTabPane.querySelector('select[name=tableDisplayTipe]').value === 'list')
    scheduleMarkup.drawDataInContainer(dayDataFromServer);
  else if(mainTabPane.querySelector('select[name=tableDisplayTipe]').value === 'listWithIcons')
    scheduleMarkupWithIcons.drawDataInContainer(dayDataFromServer);
  else
    scheduleMarkupTimeLine.drawDataInContainer(dayDataFromServer);
}

mainTabPane.querySelector('select[name=tableDisplayTipe]').addEventListener('change', () => displayDataOfOneDay());



mainTabPaneBTAdd.addEventListener('click', () => { $(newScheduleCellCardPicker).modal('show');});

newScheduleCellCardPicker.addEventListener('click', (evt) => {
  if (evt.target.attributes.typecell) {

    newScheduleCellCardEditor.setAttribute('currentEventID',0);
    currentScheduleID = false;
    $(newScheduleCellCardPicker).modal('hide');
    let cellType = evt.target.attributes.typecell.nodeValue;
  // ?  console.log(cellType);
    clearCardSimple();

    newScheduleCellCardEditorTitle.innerHTML = 'Создание элемента в расписании';
    programSelector.value = 0;
    if (cellType === 'singleRow') {
      cardProgramBlock.classList.add('divHidden');
      cardEventBlock.classList.add('divHidden');


      cellAreaTitle.placeholder = "Заезд гостей. ";
      setTimeout(function() { 
        $(newScheduleCellCardEditor).modal('show');
      },500);
    }
    else if(cellType === 'program') {
      cardProgramBlock.classList.remove('divHidden');
      cardEventBlock.classList.add('divHidden');
      cardMainActiveBlock.disabled = true;
      cardMainActiveBlock.classList.add('divDisabled');
      programSelector.disabled = false;
      programDeskSearch.value = '';
      searchInProgramDeskSearch();
      cellAreaTitle.placeholder = "Название вашей кинопрограммы для расписания.";
      setTimeout(function() { 
        $(programDesk).modal('show');
      },500);

    } else if(cellType === 'event') {
      continueCreateEventBool = false;
      cardProgramBlock.classList.add('divHidden');
      cardEventBlock.classList.remove('divHidden');
      cellAreaTitle.placeholder = "Если хотите изменить заголовок в расписании, то его нужно указать в этом поле. ";
      eventDeskInit();
      setTimeout(function() { 
         $(eventDesk).modal('show');
      },500);
    }
  
  }
});

function  eventDeskInit() {
// consts
  if(!arrEvents){
     xhr.request = {
        metod: 'GET',
        url: 'events',
        data: '',
        callbackSuccess: onSuccessEventsLoad
      };
  } else
    eventsDeskMarkup.drawDataInContainer(arrEvents);
  
  // body...
}

const onSuccessEventsLoad = (loadedPoints) => {
  eventsDeskMarkup.cleanContainer();

  if (loadedPoints.status === 200) {
    arrEvents = loadedPoints.data;
    if(continueCreateEventBool)
      openEditCardEvent(continueCreateEventId);
    else
      eventsDeskMarkup.drawDataInContainer(loadedPoints.data);
  } else {
    eventsDeskMarkup.drawMarkupInContainer(`<p>${loadedPoints.message}</p>`);
  }
};



function clearCardSimple () {
  cellAreaTitle.value = '';    
  cellAreaTitle.classList.add('notCorrect');
  cellAreaTitle.classList.add('notEdited');
  cellEditorSubmit.disabled = true;
  
  if (currentScheduleID){
    cellEditorRemove.style.opacity = 1;
    cellEditorRemove.disabled = false;
    cellEditorSubmit.innerHTML = 'Изменить';
  }
  else{
    cellEditorRemove.style.opacity = 0;
    cellEditorRemove.disabled = true;
    cellEditorSubmit.innerHTML = 'Добавить';
  }
  
  intTimeSectionsHours();

}

function intTimeSectionsHours() {
  tools.removeOptions(timeStartHourSelector);
  tools.removeOptions(timeEndHourSelector);
  let o = document.createElement('option');
  o.value = 'NULL';
  o.innerHTML = '--';
  timeEndHourSelector.appendChild(o);
  for (let i = 0; i < 24; i++) {
    let opt = document.createElement('option');
    let opt2 = document.createElement('option');
    opt.value = i;
    opt2.value = i;
    if (i < 10) {
      opt.innerHTML = '0' + i;
      opt2.innerHTML = '0' + i;
    } else {
      opt.innerHTML = i;
      opt2.innerHTML = i;
    }
    timeEndHourSelector.appendChild(opt);
    timeStartHourSelector.appendChild(opt2);
  }
}

cellAreaTitle.addEventListener('keyup',() => {
  cellAreaTitle.classList.remove('notEdited');

  cellAreaTitleVallidate();
});

function cellAreaTitleVallidate(){
   if(cellAreaTitle.value.length > 3 && cellAreaTitle.value.length < 350 || newScheduleCellCardEditor.getAttribute('currentEventID') > 0 ){
    cellAreaTitle.classList.remove('notCorrect');
    cellEditorSubmit.disabled = false;
  } else{
    cellAreaTitle.classList.add('notCorrect');
    cellEditorSubmit.disabled = true;
  }
};

cellEditorRemove.addEventListener('click', () => {
  if(confirm('Вы уверены, что хотите удалить данную запись?')){
    xhr.request = {
      metod: 'DELETE',
      url: `schedule/${currentScheduleID}`,
      data: '',
      callbackSuccess: onSuccessScheduleCell
    };
  }
});

timeStartDaySelector.addEventListener('change', () => {
  // console.log('stimeStartDaySelector');
   timeEndDaySelector.value = timeStartDaySelector.value;
   timeEndDaySelector.classList.add('changed');
    setTimeout(function() {  
      timeEndDaySelector.classList.remove('changed');
    }, 200);
});

timeStartHourSelector.addEventListener('change', () => {
  // console.log('stimeStartDaySelector');
   timeEndHourSelector.value = timeStartHourSelector.value;
   timeEndHourSelector.classList.add('changed');
    setTimeout(function() {  
      timeEndHourSelector.classList.remove('changed');
    }, 200);
});

cellEditorSubmit.addEventListener('click', () => {

  let selectedStartDay = timeStartDaySelector.options[timeStartDaySelector.selectedIndex];
  let sMonth = parseInt(selectedStartDay.getAttribute('month'), 10) + 1;
  let sDay = selectedStartDay.value;
  let sHour = timeStartHourSelector.value;
  sHour -= selectTimeZone.value;

  if (sHour < 0) {
    sHour += 24;
    sDay -=1;
  } else if (sHour > 23) {
    sHour -= 24;
    sDay +=1;
  }

// проверка смещения по месяцу!!!!

  let timeStart = `${selectedStartDay.getAttribute('year')}-${addZeroBefore(sMonth)}-${addZeroBefore(sDay)} ${sHour}:${timeStartMinSelector.value}:00`;

  // let timeEnd = (timeEndDaySelector.value != 'NULL' && timeEndHourSelector.value != 'NULL' && timeEndMinSelector.value != 'NULL') ? `&timeEnd=${text2Unix(timeEndDaySelector.value, timeEndHourSelector.value, timeEndMinSelector.value)}` : '';  
  let timeEnd = '';
  if(timeEndHourSelector.value != 'NULL'){
    let selectedEndDay = timeEndDaySelector.options[timeEndDaySelector.selectedIndex];
    let eMonth = parseInt(selectedEndDay.getAttribute('month'), 10) + 1;
    let eDay = selectedEndDay.value;
    let eHour = timeEndHourSelector.value;
    eHour -= selectTimeZone.value;

    if(eHour < 0){
      eHour += 24;
      eDay -=1;
    } else if(eHour > 23){
      
      eHour -= 24;
      eDay +=1;
    }

  // проверка смещения по месяцу!!!!

    timeEnd = `${selectedEndDay.getAttribute('year')}-${addZeroBefore(eMonth)}-${addZeroBefore(eDay)} ${eHour}:${timeEndMinSelector.value}:00`;
  };
  let bodyRequest = `name=${encodeURIComponent(cellAreaTitle.value)}&hall=${hallsSelector.value}&timeStart=${timeStart}&timeEnd=${timeEnd}&streamon=${streamsSelectorOn.value}&stream=${streamsSelector.value}`;
  if(programSelector.value > 0 )
    bodyRequest += `&program=${programSelector.value}`;

  if(newScheduleCellCardEditor.getAttribute('currentEventID') > 0)
    bodyRequest += `&event=${newScheduleCellCardEditor.getAttribute('currentEventID')}`;


  if(currentScheduleID)
    xhr.request = {
      metod: 'PUT',
      url: `schedule/${currentScheduleID}`,
      data: bodyRequest,
      callbackSuccess: onSuccessScheduleCell
    };
  else
    xhr.request = {
      metod: 'POST',
      url: 'schedule',
      data: bodyRequest,
      callbackSuccess: onSuccessScheduleCell
    };
  
});

const onSuccessScheduleCell = (servarAnswer) => {
  if (servarAnswer.status === 200) {
    $(newScheduleCellCardEditor).modal('hide');
    loadOneDay();
  }
};


function addZeroBefore(zValue){
  if(parseInt(zValue, 10) < 10)
    return `0${zValue}`;

  else 
    return zValue;
}

mainTabPaneBody.addEventListener('click', (evt) => {
  if(evt.target.attributes.action){
    let nameActon = evt.target.attributes.action.nodeValue;
    if(nameActon === 'dublicate'){
      // alert('dubl');
      xhr.request = {
        metod: 'POST',
        url: `schedule/${evt.target.attributes.scheduleid.nodeValue}/dublicate`,
        data: ``,
        callbackSuccess: onSuccessScheduleCell
      };
    }
  } else if(evt.target.attributes.scheduleid){
   
    newScheduleCellCardEditor.setAttribute('currentEventID',0);
    currentScheduleID = evt.target.attributes.scheduleid.nodeValue;
    clearCardSimple();
    let scheduleData = findDataOnID(currentScheduleID);
    
    cellAreaTitle.value = scheduleData.name;
    findPlaceOnHallID(scheduleData.hid);

    let sDay = parseInt(scheduleData.timeStart.substr(8, 2), 10);

    let sHour = parseInt(scheduleData.timeStart.substr(11, 2), 10) + parseInt(selectTimeZone.value, 10);

    if(sHour < 0){
      sHour += 24;
      sDay -=1;
    } else if(sHour > 23){
      sHour -= 24;
      sDay +=1;
    }

    timeStartDaySelector.value = sDay;
    timeStartHourSelector.value = addZeroBefore(sHour);
    timeStartMinSelector.value = addZeroBefore(parseInt(scheduleData.timeStart.substr(14, 2), 10));

    if (scheduleData.timeEnd) {
      let eDay = parseInt(scheduleData.timeEnd.substr(8, 2), 10);
      let eHour = parseInt(scheduleData.timeEnd.substr(11, 2), 10) + parseInt(selectTimeZone.value, 10);
      if(eHour < 0){
        eHour += 24;
        eDay -=1;
      } else if(eHour > 23){
        eHour -= 24;
        eDay +=1;
      };

      timeEndDaySelector.value = eDay;
      timeEndHourSelector.value = (eHour);
      timeEndMinSelector.value = addZeroBefore(parseInt(scheduleData.timeEnd.substr(14, 2), 10));
    } else {
      timeEndDaySelector.value = sDay;
      timeStartMinSelector.value = '00';
      timeEndHourSelector.value = 'NULL';
    }

    cellAreaTitleVallidate();
    
    // cardProgramBlock.classList.remove('divHidden');
      // cardMainActiveBlock.classList.remove('divDisabled');
    
    newScheduleCellCardEditorTitle.innerHTML = 'Редактирование элемента в расписании';

    if(scheduleData.programID){
      // карточка программы

      cardProgramBlock.classList.remove('divHidden');
      cardMainActiveBlock.disabled = true;
      cardMainActiveBlock.classList.remove('divDisabled');
      programSelector.disabled = true;
      programSelector.value = scheduleData.programID;
      displayFilmsInProgramms();
      cardEventBlock.classList.add('divHidden');

    } else if(scheduleData.eventID) {
      programSelector.value = 0;

      // карточка события
      cardMainActiveBlock.disabled = true;
      cardMainActiveBlock.classList.remove('divDisabled');
      newScheduleCellCardEditor.setAttribute('currentEventID',scheduleData.eventID);
      cardEventBlock.classList.remove('divHidden');
      cardProgramBlock.classList.add('divHidden');
      cardEventBlockTitle.innerHTML = scheduleData.eTitle;
      if(scheduleData.eDesc)
        cardEventBlockDescription.innerHTML = tools.texWithLinks(scheduleData.eDesc.replace(/\n/g, "<br>"));
      else
        cardEventBlockDescription.innerHTML = '';

      let urlImg = '';
      if(scheduleData.eImage)
        urlImg = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/events/${scheduleData.eImage}.jpg`;
      else
        urlImg = 'https://festapp.ru/lk/img/f_bg_main4.jpg';
      cardEventBlockImg.src = urlImg;

    } else {
      programSelector.value = 0;
      cardProgramBlock.classList.add('divHidden');
      cardEventBlock.classList.add('divHidden');
      //карточка обычной строки
    }

    streamsSelector.value = scheduleData.stream ? scheduleData.stream : false;
    streamsSelectorOn.value = scheduleData.streamOn ? scheduleData.streamOn : 0;
    configureStreamInfo(scheduleData.stream);

    setTimeout(function() { 
      $(newScheduleCellCardEditor).modal('show');
    },500);
    
 

  } else if(evt.target.attributes.fcid){ // открытие карточки фильма
    filmApplicationsForConsiderJS.loadRequestFilmApplication(evt.target.attributes.fcid.nodeValue);    
  }
});

function configureStreamInfo (streamID) {
  newScheduleCellCardEditor.querySelector('small[name=streamDetail]').innerHTML = '';
 
  if(availableStreams && streamID)
    availableStreams.forEach((element) => {
      if (element.id == streamID)
        newScheduleCellCardEditor.querySelector('small[name=streamDetail]').innerHTML = `Доступна до: ${element.timeEnd}  (UTC) Максимальное кол-во просмотров: ${element.maxView}`;
      
    })

  if (streamID)
    streamsSelectorOn.classList.remove('divDisabled');
  else
    streamsSelectorOn.classList.add('divDisabled');

}
function findPlaceOnHallID(hallID){
  if(arrLocations)
    arrLocations.forEach((elem) => {
      if(elem.halls)
        elem.halls.forEach((helem) => {
          if(tools.checkEqualTwoInt(helem.id, hallID)){
            locationSelector.value = elem.id;
          }
        });
    });
  displayHalls();
  hallsSelector.value = hallID;

  // console.log(locationSelector);
}

function findDataOnID(searchID) {
  // console.log(allLoadedData);
  searchID = parseInt(searchID, 10);
  for (let i = dayDataFromServer.length - 1; i >= 0; i--) {
    if (parseInt(dayDataFromServer[i].id, 10) === searchID) {
      return dayDataFromServer[i];
    }
  }
  return 0;
}

programDesk.addEventListener('click', function (evt) {
  // console.log(evt.target.attributes);
  if(evt.target.attributes.pID){

      programSelector.value = evt.target.attributes.pID.nodeValue;
      programSelect(evt.target.attributes.pName.nodeValue);
      
      $(programDesk).modal('hide');
      programDeskSearch.value = '';
      setTimeout(function() { 
        $(newScheduleCellCardEditor).modal('show');
      },500);
    }
  // body...
});


eventDesk.addEventListener('click', function (evt) {
  if (evt.target.attributes.eventid) 
    openEditCardEvent(evt.target.attributes.eventid.nodeValue);
  // body...
});

function openEditCardEvent(eventID){
  $(eventDesk).modal('hide');
  cardEventBlock.classList.remove('divHidden');
  cardProgramBlock.classList.add('divHidden');
  cardMainActiveBlock.disabled = true;
  cardMainActiveBlock.classList.remove('divDisabled');
  arrEvents.forEach((eElement) =>{
    if(parseInt(eElement.id, 10) === parseInt(eventID, 10)){

      newScheduleCellCardEditor.setAttribute('currentEventID',eElement.id);

      cardEventBlockTitle.innerHTML = eElement.name;
      cellAreaTitle.value = eElement.name;
      if(eElement.description)
        cardEventBlockDescription.innerHTML = tools.texWithLinks(eElement.description.replace(/\n/g, "<br>"));
      else
        cardEventBlockDescription.innerHTML = '';

      // cardEventBlockImg.src = eElement.image;
      let urlImg = '';
      if(eElement.image)
        urlImg = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/events/${eElement.image}.jpg`;
      else
        urlImg = 'https://festapp.ru/lk/img/f_bg_main4.jpg';
      cardEventBlockImg.src = urlImg;
    }
  });
  cellAreaTitle.placeholder = "Если хотите изменить заголовок в расписании, то его нужно указать в этом поле. ";
  // programDeskSearch.value = '';
  cellAreaTitleVallidate();
  setTimeout(function() { 
    $(newScheduleCellCardEditor).modal('show');
  },500);

}

eventDeskCreate.addEventListener('click', function (evt) {
  continueCreateEventId = 0;
   xhr.request = {
        metod: 'POST',
        url: `events/0/new`,
        data: ``,
        callbackSuccess: onSuccessCreateEmptyCard
      };
});


cardEventBlock.addEventListener('click', function (evt) {
  $(newScheduleCellCardEditor).modal('hide');
  continueCreateEventBool = true;
  continueCreateEventId = newScheduleCellCardEditor.getAttribute('currentEventID')
  setTimeout(function() { 
    eventJs.openEditCard(newScheduleCellCardEditor.getAttribute('currentEventID'), true);
  })
});


const onSuccessCreateEmptyCard = (servarAnswer) => {
  // arrFilms = [];  

  $(eventDesk).modal('hide');
  continueCreateEventBool = true;
  if (servarAnswer.status === 200)
    eventJs.openEditCard(servarAnswer.data, true);
  
};

function continueCreateEvent(eventID) {
  arrEvents = false;
  continueCreateEventId = eventID;
  eventDeskInit();
}


programDeskSearch.addEventListener('keyup', function (evt) {
  searchInProgramDeskSearch();
});

function searchInProgramDeskSearch(){
  let arrProgramsCopy = [];
  // alert('dfg');
  if (programDeskSearch.value.length > 0) 
    arrPrograms.forEach((element) => {
      if(tools.kmpSearch(programDeskSearch.value,element.name ) != -1)
        arrProgramsCopy.push(element);
    });
  else 
    arrProgramsCopy = arrPrograms.slice();

 if(arrPrograms&& arrFilms){

  // сортировка

    let arrDisplaySorted = [];
    if(mainTabPaneBTDataSort.value == -1) 
      arrDisplaySorted = arrProgramsCopy.sort(function(b, a) {
            return parseInt(a.id, 10) - parseInt(b.id, 10);
         });
    else if(mainTabPaneBTDataSort.value == 0) 
      arrDisplaySorted = arrProgramsCopy.sort(function(a, b) {
            return parseInt(a.id, 10) - parseInt(b.id, 10);
         }); 
    

    if(arrDisplaySorted)
      runProgramDeskMarkup(arrDisplaySorted, arrPrograms, arrFilms);
    else
      programDeskMarkupList.drawMarkupInContainer(`<p>Ничего не найдено!</p>`);
   }
}
function runProgramDeskMarkup(arrProgramsCopy,arrPrograms,arrFilms){

  if (parseInt(mainTabPaneBTDataDisplay.value) === 1)
      programDeskMarkupList.drawDataInContainer(arrProgramsCopy, arrPrograms, arrFilms);
    else
      programDeskMarkup.drawDataInContainer(arrProgramsCopy, arrPrograms, arrFilms);
}

eventDeskSearch.addEventListener('keyup', function (evt) {

  let arrEventCopy = [];

    arrEvents.forEach((element) => {
      if(tools.kmpSearch(eventDeskSearch.value,element.name ) != -1)
        arrEventCopy.push(element);
    });

   if(arrEventCopy)
      eventsDeskMarkup.drawDataInContainer(arrEventCopy);
    else
      eventsDeskMarkup.drawMarkupInContainer(`<p>Ничего не найдено!</p>`);
 

});


export default {

  continueCreateEventPublic(eventID){
    continueCreateEvent(eventID)
  },

  publicReloadPrograms(){
    reloadPrograms();
  },

  start() {
    currentscheduleDayIndex = 0;
    // initBTDaysFest();
    // // getAllLocations();
    // intTimeSectionsHours();
    // getPoints();
    menuBt.addEventListener('click', initFirstSetup);
  },

  redraw: continueCreateEvent,

  stop() {
    scheduleMarkup.cleanContainer();
    menuBt.removeEventListener('click', initFirstSetup);
  }
};
